self.fetch || (self.fetch = function (e, n) {
    return n = n || {},
    new Promise(function (t, s) {
        var r = new XMLHttpRequest,
            o = [],
            u = [],
            i = {},
            a = function () {
                return {
                    ok: 2 == (r.status / 100 | 0),
                    statusText: r.statusText,
                    status: r.status,
                    url: r.responseURL,
                    text: function () {
                        return Promise.resolve(r.responseText)
                    },
                    json: function () {
                        return Promise.resolve(JSON.parse(r.responseText))
                    },
                    blob: function () {
                        return Promise.resolve(new Blob([r.response]))
                    },
                    clone: a,
                    headers: {
                        keys: function () {
                            return o
                        },
                        entries: function () {
                            return u
                        },
                        get: function (e) {
                            return i[e.toLowerCase()]
                        },
                        has: function (e) {
                            return e.toLowerCase() in i
                        }
                    }
                }
            };
        for (
            var c in r.open(n.method || "get", e, !0),
            r.onload = function () {
                r
                    .getAllResponseHeaders()
                    .replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (e, n, t) {
                        o.push(n = n.toLowerCase()),
                        u.push([n, t]),
                        i[n] = i[n]
                            ? i[n] + "," + t
                            : t
                    }),
                t(a())
            },
            r.onerror = s, 
            r.withCredentials = "include" == n.credentials,
            n.headers
        ) 
            r.setRequestHeader(c, n.headers[c]);
        r.send(n.body || null)
    })
});

// Func = limiting Scope for this file
(function () {
    if ('NodeList' in window && !NodeList.prototype.forEach) {
        console.info('polyfill for IE11');
        NodeList.prototype.forEach = function (callback, thisArg) {
            thisArg = thisArg || window;
            for (var i = 0; i < this.length; i++) {
                callback.call(thisArg, this[i], i, this);
            }
        };
    }

    function resizeWindow() {}
    function scrollDown() {
        let top = $(document).scrollTop();
        if (top > 0) {} else {}
    }

    // Burger menu
    let button = document.querySelector('.burger-menu');
    let header_logo = document.querySelector('.header-logo .logo');
    let menu_open = document.querySelector('.menu-open');
    /* let menu_open_title = document.querySelector('.menu-open-title'); */
    /* let menu_arrow_animate = document.querySelector('.menu-open-title .arrow-animate');
	let menu_arrow_animate_after = document.querySelector('.menu-open-title .arrow-animate.after'); */
    let menu_close = document.querySelector('span.burger-title-close');
    let line = document.querySelector('.line.top');
    let line2 = document.querySelector('.line.down');

    if (button) {
        button.addEventListener('click', event => {
            button
                .classList
                .toggle("change");
            header_logo
                .classList
                .toggle("open-menu");
            menu_open
                .classList
                .toggle("open-menu");
            /* menu_open_title.classList.toggle("open-menu"); */
            /* menu_arrow_animate.classList.toggle("open-menu");
			menu_arrow_animate_after.classList.toggle("open-menu"); */
            menu_close
                .classList
                .toggle("hidden");
            line
                .classList
                .toggle("anima_line");
            line2
                .classList
                .toggle("anima_line");

        });
    }

    //Footer Signup button class
    let signup_button = document.querySelector('.signup-btn');
    if (signup_button) {
        signup_button
            .classList
            .add("btn", "gold", "txt-black");
    }

    let play_vid = document.querySelectorAll(".playVid");
    let pause_vid = document.querySelectorAll(".pauseVid");

    function playVid(vid) {
        vid.play();
    }

    function pauseVid(vid) {
        vid.pause();
    }

    if (play_vid) {
        play_vid.forEach(function (item) {
            item.addEventListener('click', function () {
                let video_container = this.closest('.container');
                let video = video_container.querySelector('.video-user');
                let video_pause = video_container.querySelector('.pauseVid');
                playVid(video);
                this
                    .classList
                    .add('hide');
                video_pause
                    .classList
                    .remove('hide');
            });
        });
    }

    if (pause_vid) {
        pause_vid.forEach(function (item) {
            item.addEventListener('click', function () {
                let video_container = this.closest('.container');
                let video = video_container.querySelector('.video-user');
                let video_play = video_container.querySelector('.playVid');
                pauseVid(video);
                this
                    .classList
                    .add('hide');
                video_play
                    .classList
                    .remove('hide');
            });
        });
    }

    let submenu_open = document.querySelectorAll('#privary-navigation > li');
    let last_submenu_active = '';

    if (submenu_open) {
        submenu_open.forEach(function (item) {
            item.addEventListener('click', function () {

                if (this.classList.contains('submenu-open')) {
                    last_submenu_active
                        .classList
                        .remove('submenu-open');
                } else {
                    if (last_submenu_active != '') {
                        last_submenu_active
                            .classList
                            .remove('submenu-open');
                        last_submenu_active = this;
                    } else {
                        last_submenu_active = this;
                    }
                    this
                        .classList
                        .add('submenu-open');
                }
            });
            if (item.children.length > 1) {
                item
                    .classList
                    .add('has-submenu');
                    item.querySelector("a").addEventListener("click" , function () {
                        event.preventDefault();
                    });
            }
        });
    }

    

    $(document).ready(function () {
        
        if($('body#gallery')){
            var HeightTopHeader = $('#header').height();
            $("#myGallery").css("margin-top", HeightTopHeader - 5);
        }

        //get url of window in accommodations
        let windowURL = window.location.href;
        //target
        if(windowURL.indexOf('#') > -1){
            
            let target = windowURL.split('#')[1];
            setTimeout(function(){
                animateTo(target);
            },1000);
            
        }

        if(document.getElementsByClassName('toLink').length > 0){
            for(let i = 0; i < document.getElementsByClassName('toLink').length; i++){
                document.getElementsByClassName('toLink')[i].addEventListener('click',function(e){
                    e.preventDefault();
                    let currentTarget = this.getAttribute('href').split('#')[1];
                    animateTo(currentTarget);
                });
            }
        }

        $('#content .btn').wrapInner('<span></span>');

        //home alamo banner
        if(document.getElementsByClassName('alamo-banner').length > 0){
            document.getElementsByTagName('header')[0].classList.add('homebanner');
            document.getElementsByClassName('home-top-content')[0].classList.add('homebanner');
        }

        $('#footer .signup-btn').appendTo('#footer .fields-wrap');
        $('#footer .signup-btn').wrap('<div class="signup-btn-wrap">');

        $('#booking-form .form-entry select').change(function () {
            let thisVal = $(this).val();
            $(this)
                .siblings('.select-text')
                .text(thisVal);
        })

        //Call function with browser is resized.
        $(window).resize(function (event) {
            resizeWindow();
        });
        resizeWindow();

        // Acts when scroll down page. $(window).scroll(function (event) {
        // scrollDown(); }); Main Nav Dropdown $("#primary-nav li").hover(function(){
        // $(this).addClass("hover"); 	$('ul.submenu',this).fadeIn(200); }, function(){
        // $(this).removeClass("hover"); 	$('ul.submenu',this).fadeOut(200); });
        // Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
        let DATE_STYLE = [true];
        function calendarRange(date) {
            let d1 = $
                .datepicker
                .parseDate(DATE_FORMAT, $('#CheckIn').val());
            let d2 = $
                .datepicker
                .parseDate(DATE_FORMAT, $('#CheckOut').val());
            if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
                DATE_STYLE[1] = 'highlight-top';
            } else if (date > d1 && date < d2) {
                DATE_STYLE[1] = 'highlight';
            } else {
                DATE_STYLE[1] = '';
            }
            return DATE_STYLE;
        }

        //Check in and check out datepicker for booking engine
        const DATE_FORMAT = (
            $("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")
        )
            ? $("#CheckIn").data("format")
            : "yy-mm-dd";
        $("#CheckIn").datepicker({
            // showOn: "both", buttonImage: SITE_FILES+"images/img-calendar-gray.png",
            // buttonImageOnly: true,
            dateFormat: "mm.dd.y",
            altField: "#CheckIn__alt",
            altFormat: DATE_FORMAT,
            numberOfMonths: 1,
            minDate: new Date(2020, 5 - 1, 1),
            //beforeShowDay: (date) => calendarRange(date),
            onSelect: function (selectedDate) {
                let getDate = $(this).datepicker('getDate');
                let newDate = new Date(getDate.getTime());
                newDate.setDate(newDate.getDate() + 3);
                $("#CheckOut").datepicker("setDate", newDate);
                $("#CheckOut").datepicker("option", "minDate", selectedDate);
            }
        });
        $("#CheckOut").datepicker({
            // showOn: "both", buttonImage: SITE_FILES+"images/img-calendar-gray.png",
            // buttonImageOnly: true,
            dateFormat: "mm.dd.y",
            altField: "#CheckOut__alt",
            altFormat: DATE_FORMAT,
            changeMonth: true,
            numberOfMonths: 1,
            minDate: new Date(2020, 5 - 1, 1),
            //beforeShowDay: (date) => calendarRange(date),
            onSelect: function (selectedDate) {
                //$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
            }
        });
        // Slick slider with count numbers
        $(".numbers-slider").each(function () {
            let $thisEl = $(this);
            let $thisWrapper = $thisEl.closest('.numbers-slider__wrapper');
            let $thisCount = $thisWrapper.find('.numbers-slider__count');
            let $thisDots = $thisWrapper.find('.dots-wrapper');
            $thisEl.slick({
                arrows: true,
                dots: false,
                autoplay: false,
                fade: true,
                accessibility: true,
                adaptiveHeight: true,
                appendArrows: $thisDots
            });
            $thisEl.on(
                "init beforeChange",
                function (event, slick, currentSlide, nextSlide) {
                    if (nextSlide < 9) {
                        $thisCount
                            .find('.dots-current')
                            .html("0" + (
                                nextSlide + 1
                            ));
                    } else {
                        $thisCount
                            .find('.dots-current')
                            .html(nextSlide + 1);
                    }
                }
            );
        });

        // Slick slider with count numbers
        $(".amenities-slider").each(function () {
            let $thisEl = $(this);
            let $thisWrapper = $thisEl.closest('.numbers-slider__wrapper');
            let $thisCount = $thisWrapper.find('.numbers-slider__count');
            $thisEl.slick();
            $thisEl.on(
                "init beforeChange",
                function (event, slick, currentSlide, nextSlide) {
                    if (nextSlide < 9) {
                        $thisCount
                            .find('.dots-current')
                            .html("0" + (
                                nextSlide + 1
                            ));
                    } else {
                        $thisCount
                            .find('.dots-current')
                            .html(nextSlide + 1);
                    }
                }
            );
        });

        // Position pin map
        $('.pin-map').click(function () {
            let this_index = $(this).index();
            $('#map-slider').slick('slickGoTo', this_index);
        });

        $('#map-slider').on(
            "beforeChange",
            function (event, slick, currentSlide, nextSlide) {
                let this_pin = document.getElementsByClassName('pin-map')[nextSlide];
                $('.pin-map').removeClass('active');
                this_pin
                    .classList
                    .add('active');
            }
        );

        // Map: Return to previous page button. Change body id to match map template's
        // name.
        $('body#map-category #content').prepend(
            '<a class="btn gold txt-white  return-from-map" href="javascript:history.back()' +
            '"><span>Back to previous page</span></a>'
        );
        $('body#map-category #content').prepend(
            '<a class="btn gold txt-white go-to-ada" href="/ada-map"><span>ADA map</span></' +
            'a>'
        );

        $('#privary-navigation a').click(function (event) {
            if ($(this).siblings('.submenu').size() > 0) {
                event.preventDefault();
            }
        });

    });

    $(window).on('load', function(){ 
        //Preloader
        $('#preloader').fadeOut('slow');
        $('body').css({'overflow': 'visible'});

        $('#special-8286 .btn span').html('Sign me up');

        // $('h1 span').prepend("<span class='image-dot title-animate'><img
        // src='/assets/images/svg/triangle.svg' alt='Arrow triangle'
        // class='img-triangle'><img src='/assets/images/svg/dot.svg' alt='Arrow dot'
        // class='img-dot'></span>"); let title_triangle = $('.img-triangle');
        // setTimeout(function() { 	title_triangle.addClass('animate'); }, 400); let
        // title_dot = $('.img-dot'); setTimeout(function() {
        // title_dot.addClass('animate'); }, 400); let title_line = $('.image-dot');
        // setTimeout(function() { 	title_line.addClass('animate'); }, 400);

    });

}());

//vanilla js scroll animation

function animateTo(target){
	var gotoTarget = offset(document.getElementById(target)).top - 150;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300; 
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var y = easeInOutQuart(time, from, to - from, duration)
		} else {
			
			var y = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, y)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}